import { render, staticRenderFns } from "./PhoneFindPwd.vue?vue&type=template&id=1d9bc372&scoped=true&"
import script from "./PhoneFindPwd.vue?vue&type=script&lang=js&"
export * from "./PhoneFindPwd.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFindPwd.vue?vue&type=style&index=0&id=1d9bc372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9bc372",
  null
  
)

export default component.exports